import * as React from 'react';
import styles from './avatar.module.css';
import { AvatarCode as AvatarCodeType } from 'services/accounts/types';
import { AvatarCode } from 'services/accounts/protos/user_dto_pb';
import Avatar1 from './assets/ic_avatar0.png';
import Avatar2 from './assets/ic_avatar1.png';
import Avatar3 from './assets/ic_avatar2.png';
import Avatar4 from './assets/ic_avatar3.png';
import Avatar5 from './assets/ic_avatar4.png';
import Avatar6 from './assets/ic_avatar5.png';

export const avatarImages: Record<AvatarCodeType, string> = {
  [AvatarCode.ONE]: Avatar1,
  [AvatarCode.TWO]: Avatar2,
  [AvatarCode.THREE]: Avatar3,
  [AvatarCode.FOUR]: Avatar4,
  [AvatarCode.FIVE]: Avatar5,
  [AvatarCode.SIX]: Avatar6,
};

type AvatarProps = {
  avatarCode: AvatarCodeType;
};

export const Avatar = React.memo(({ avatarCode }: AvatarProps) => {
  return (
    <img src={avatarImages[avatarCode]} className={styles.avatar} alt='avatar'/>
  );
});
Avatar.displayName = 'Avatar';
